import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(2, 3, 6),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(7, 7, 6),
      '&:first-child': {
        paddingTop: theme.spacing(7),
      },
    },
  },
  dialogActions: {
    padding: theme.spacing(0, 3, 3),
    justifyContent: 'flex-end',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 7, 5),
    },
  },
}))

export default useStyles
